import { useSite } from "../context/SiteContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UsageRing from "../components/UsageRing";

function Areas() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { selectedSite, areas, platesByArea, selectedArea, setareaId } = useSite();

  const userRoleHigherOpener = localStorage.getItem("actualUserRole") != "gate_opener";

  const goToDetails = (areaId) => {
    setareaId(areaId);
    navigate(`/details`);
  };

  if (!selectedSite) return null;

  return (
    <div className="p-4 border ez-rounded-card bg-white shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">{selectedSite.name}</h4>
        {userRoleHigherOpener && (
          <button className="btn btn-sm btn-light" onClick={() => navigate('/site-settings')} title={t('Site settings')}>
            <i className="bi bi-gear me-1"></i>{t('Site settings')}
          </button>
        )}
      </div>

      {areas.length === 0 ? (
        <p>{t("No areas found for this site")}</p>
      ) : (
        <div className="row g-3">
          {areas.map((area) => {
            const areaPlates = platesByArea[area.id] || [];

            return (
              <div key={area.id} className="col-6 col-md-4 col-lg-4">
                <div
                  id={`area-tile-${area.id}`}
                  className="area-tile position-relative text-center p-3 border rounded-3 h-100"
                  onClick={() => goToDetails(area.id)}
                  style={{ cursor: "pointer" }}
                >
                  {userRoleHigherOpener && area.deleted_still_active > 0 ? (
                    // a removed plate can still open the gate — more urgent than a pending sync
                    <i
                      id={`area-sync-warning-${area.id}`}
                      className="bi bi-exclamation-octagon-fill text-danger position-absolute"
                      style={{ top: "0.5rem", right: "0.6rem" }}
                      title={t("deleted_still_active_title", { count: area.deleted_still_active })}
                    ></i>
                  ) : userRoleHigherOpener && area.unsynced_plates > 0 && (
                    <i
                      id={`area-sync-warning-${area.id}`}
                      className="bi bi-exclamation-triangle-fill text-warning position-absolute"
                      style={{ top: "0.5rem", right: "0.6rem" }}
                      title={t("sync_not_synced", { count: area.unsynced_plates })}
                    ></i>
                  )}
                  <div className="area-icon mb-2">
                    <i className={`bi ${area.icon || 'bi-p-circle'} fs-2 text-ez-orange`}></i>
                  </div>
                  <div className="area-name fw-semibold mb-2">{area.name}</div>

                  {userRoleHigherOpener && (
                    <UsageRing
                      value={areaPlates.length}
                      total={area.total_spaces ?? 100}
                      label={t("Licenses")}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Areas;
